export const mascaraTelefone = (value: string) => {
  if(!value || typeof value !== 'string') return ""
  const telefoneFixo = value.length <= 14

  if (telefoneFixo) {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d{4})/, '$1-$2')
  }

  if (value.length > 15) {
    return value
  }
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})/, '$1-$2')
}
